import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { selected, reset } from './index';
import useSelectorTyped from '../useSelectorTyped';
import { ClassSectionState } from './index';

const useClassSection = () => {
  const dispatch = useDispatch();

  const classSectionState = useSelectorTyped(state => state.classSection);

  const onSelectedClassSection = useCallback(
    (classSection: ClassSectionState) => dispatch(selected(classSection)),
    [dispatch]
  );

  const onResetClassSection = useCallback(() => dispatch(reset()), [dispatch]);

  return {
    ...classSectionState,
    onSelectedClassSection,
    onResetClassSection,
  };
};

export default useClassSection;
